<div class="table-container fx-layout-column fx-layout-align-start-m">
  @if (this.usersService.userPermissions.tierTwo) {
    <div>
      <mat-card class="dashboard-card-link" routerLink="/my-services">
        <mat-card-content>
          <span class="mat-card-title">My Services</span>
        </mat-card-content>
      </mat-card>
    </div>
  }

  @if (this.usersService.userPermissions.tierThree) {
    <div>
      <mat-card class="dashboard-card-link" routerLink="/my-cases">
        <mat-card-content>
          <span class="mat-card-title">My Cases</span>
        </mat-card-content>
      </mat-card>
    </div>
  }

  @if (this.usersService.userPermissions.tierThree && this.usersService.showELearningBtn == true) {
    <div>
      <mat-card class="dashboard-card-link" (click)="navigateMyELearning()">
        <mat-card-content>
          <span class="mat-card-title">My eLearning</span>
        </mat-card-content>
      </mat-card>
    </div>
  }

  @if (this.usersService.userPermissions.tierThree && this.usersService.showResourcesBtn == true) {
    <div>
      <mat-card class="dashboard-card-link" routerLink="/my-resources">
        <mat-card-content>
          <span class="mat-card-title">My Resources</span>
        </mat-card-content>
      </mat-card>
    </div>
  }

  @if (this.usersService.userPermissions.tierThree) {
    <div>
      <mat-card class="dashboard-card-link" routerLink="/my-documents">
        <mat-card-content>
          <span class="mat-card-title">My Documents</span>
        </mat-card-content>
      </mat-card>
    </div>
  }

  @if (this.usersService.userPermissions.tierOne) {
    <div>
      <mat-card class="dashboard-card-link" routerLink="/my-financials">
        <mat-card-content>
          <span class="mat-card-title">My Financials</span>
        </mat-card-content>
      </mat-card>
    </div>
  }

  @if (this.usersService.userPermissions.tierOne) {
    <div>
      <mat-card class="dashboard-card-link" routerLink="/my-users">
        <mat-card-content>
          <span class="mat-card-title">My Users</span>
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>
